/* eslint-disable @change-corgi/require-data-qa-attribute */
import { useI18n } from '@change-corgi/core/react/i18n';
import { RadioGroup } from '@change-corgi/design-system-legacy/components/forms';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box } from '@change-corgi/design-system-legacy/layout';

import type { StarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { RadioCard } from 'src/app/shared/components/forms';
import { ScrollContainer } from 'src/app/shared/components/ScrollContainer';

import { useShareVisualModalBody } from '../../hooks/useShareVisualModalBody';

type Petition = StarterDashboardV2PageData['petition'];
type Context = 'starter_dashboard_grow_petition';
type Props = { petition: Petition; context: Context; onChange: () => void };

export function ShareVisualContent({ petition, context, onChange }: Props): JSX.Element {
	const { data } = useShareVisualModalBody({ petition, context });
	const { translate } = useI18n();
	return (
		<RadioGroup
			aria-label={translate('corgi.petition.starter_dashboard.shared.share_visuals.modal_form_aria_label')}
			name="share-visuals"
			onChange={onChange}
		>
			<ScrollContainer
				as="div"
				sx={{
					/* eslint-disable @typescript-eslint/naming-convention */
					'& > ul': {
						gridTemplateColumns:
							data.shareVisuals.length > 2
								? [
										`repeat(${data.shareVisuals.length}, minmax(219px, 1fr))`,
										`repeat(${data.shareVisuals.length}, minmax(31%, 1fr))`,
										`repeat(${data.shareVisuals.length}, minmax(22.5%, 1fr))`,
									]
								: 'repeat(2, 1fr)',
						paddingBottom: '24px',
						paddingLeft: '8px',
						paddingRight: '8px',
						'& > li': {
							padding: 2,
						},
					},
					/* eslint-enable @typescript-eslint/naming-convention */
				}}
			>
				{data.shareVisuals.map((shareVisual) => (
					<RadioCard
						key={shareVisual.id}
						label={
							<Box
								sx={{
									aspectRatio: '1/1',
									backgroundColor: 'primary-greyBackground',
									padding: '8px 8px 0',
									lineHeight: 0,
								}}
							>
								<Image
									src={shareVisual.image.src}
									srcSet={shareVisual.image.srcSet}
									alt={shareVisual.image.alt}
									sx={{ borderRadius: 'standard' }}
								/>
							</Box>
						}
						value={shareVisual.variantName}
					/>
				))}
			</ScrollContainer>
		</RadioGroup>
	);
}
